"use client";

import { useState } from "react";
import {
  HoveredLink,
  Menu,
  MenuItem,
  ProductItem,
} from "@/components/ui/navbar-menu";
import {
  type HoveredLinkData,
  navMenuData,
  type ProductItemData,
} from "@/lib/_data/navData";

function isProductItem(
  item: ProductItemData | HoveredLinkData
): item is ProductItemData {
  return "src" in item && "title" in item;
}

export function NavDiyer() {
  const [active, setActive] = useState<string | null>(null);

  const renderMenuItemContent = (
    content: (typeof navMenuData)[0]["content"]
  ) => {
    if (content.layout === "grid") {
      // Determine number of columns based on items length
      const columnCount = content.items.length;
      const gridColsClass =
        columnCount === 1
          ? "grid-cols-1"
          : columnCount === 2
            ? "grid-cols-2"
            : columnCount === 3
              ? "grid-cols-3"
              : "grid-cols-4";
      return (
        <div className={`grid ${gridColsClass} gap-4 text-sm`}>
          {content.items.map((column) => {
            const firstItem = column[0];
            const columnKey = firstItem
              ? isProductItem(firstItem)
                ? `${firstItem.href}-${firstItem.title}`
                : `${firstItem.href}-${firstItem.label}`
              : `col-${Math.random()}`;
            return (
              <div
                className={`flex flex-col ${
                  content.type === "products" ? "space-y-4" : "space-y-3"
                } text-sm`}
                key={columnKey}
              >
                {column.map((item) => {
                  if (isProductItem(item)) {
                    return (
                      <ProductItem
                        description={item.description}
                        href={item.href}
                        key={`${item.href}-${item.title}`}
                        src={item.src}
                        title={item.title}
                      />
                    );
                  }
                  return (
                    <HoveredLink
                      href={item.href}
                      key={`${item.href}-${item.label}`}
                    >
                      {item.label}
                    </HoveredLink>
                  );
                })}
              </div>
            );
          })}
        </div>
      );
    }
    return (
      <div className="flex flex-col space-y-4 text-sm">
        {content.items[0]?.map((item) => {
          if (isProductItem(item)) {
            return (
              <ProductItem
                description={item.description}
                href={item.href}
                key={`${item.href}-${item.title}`}
                src={item.src}
                title={item.title}
              />
            );
          }
          return (
            <HoveredLink href={item.href} key={`${item.href}-${item.label}`}>
              {item.label}
            </HoveredLink>
          );
        })}
      </div>
    );
  };

  return (
    <div className="flex items-center space-x-4">
      <Menu setActive={setActive}>
        {navMenuData.map((menuItem) => (
          <MenuItem
            active={active}
            item={menuItem.label}
            key={menuItem.label}
            {...(menuItem.href && { href: menuItem.href })}
            setActive={setActive}
          >
            {renderMenuItemContent(menuItem.content)}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

export default NavDiyer;
